/* src/app/shared/components/layout/toolbar/toolbar.component.scss */
:host.toolbar--noAuth {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
/*# sourceMappingURL=toolbar.component.css.map */
